import { createRoot } from "react-dom/client";
import Providers from "./providers/provider";

import * as React from "react";
import Routing from "./routes/routing";

const root = createRoot(document.getElementById("app") as HTMLElement);

root.render(
  <React.StrictMode>
    <Providers>
      <Routing />
    </Providers>
  </React.StrictMode>
);
